<template>
  <div class="flex items-center" v-if="property">
    <div class="hidden border rounded-full border-primary md:flex md:flex-col">
      <div class="border border-white rounded-full" v-if="property.agent.photo">
        <img
          :src="property.agent.photo"
          class="w-6 h-6 rounded-full md:w-8 md:h-8"
          alt=""
        />
      </div>
      <div
        v-else
        class="items-center justify-center hidden w-6 h-6 font-semibold text-white rounded-full md:flex bg-primary md:w-8 md:h-8"
      >
        {{ $getInitials(property.agent.name) }}
      </div>
    </div>
    <p class="md:pl-2 pl-1 md:text-xs text-[9px]">
      Listed {{ property.listed_on }}
    </p>
  </div>
</template>
<script>
export default {
  props: {
    property: Object,
  },
};
</script>
